export enum beneficiaryTypeViewModes {
  bankTransfer = "bankTransfer",
  gatewayTransfer = "gatewayTransfer",
}
